/** @format */

import template from './gb-table-pagination.html';

export const GbTablePaginationComponent = {
    template,
    bindings: {
        rows: '<',
        total: '<?',
        limit: '=?',
        page: '=?',
        offset: '=?',
        onPaginate: '&',
        limitOptions: '<?',
    },
    controller: class GbTablePaginationComponent {
        constructor($timeout) {
            'ngInject';

            this.$timeout = $timeout;

            this.total = 0;
            this.limit = 10;
            this.page = 1;
            this.offset = 0;
            this.limitOptions = [10, 20, 50, 100];
        }

        onPageChange() {
            this.offset = (this.page - 1) * this.limit;

            let options = {
                limit: this.limit,
                offset: this.offset,
            };

            // Called after one digest loop so that two way bindings will be set to new values
            this.$timeout(() => {
                this.onPaginate({
                    $options: options,
                });
            });
        }

        getTotal() {
            if (Array.isArray(this.rows) && this.rows._total) {
                return this.rows._total;
            }

            return this.total;
        }
    },
};
